import(/* webpackMode: "eager" */ "/opt/build/repo/application/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Montserrat\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-sans\"}],\"variableName\":\"fontSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/application/node_modules/onborda/dist/Onborda.js");
;
import(/* webpackMode: "eager", webpackExports: ["OnbordaProvider","useOnborda"] */ "/opt/build/repo/application/node_modules/onborda/dist/OnbordaContext.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/application/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["CookieSync"] */ "/opt/build/repo/application/src/components/auth/cookie-sync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NuqsAdapter"] */ "/opt/build/repo/application/src/components/event-calendar/nuqs-adapter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TourCard"] */ "/opt/build/repo/application/src/components/onboarda/tour-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BroadcastChannelProvider"] */ "/opt/build/repo/application/src/components/providers/broadcast-channel-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocalStorageProvider"] */ "/opt/build/repo/application/src/components/providers/LocalStorageProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/opt/build/repo/application/src/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/opt/build/repo/application/src/components/ui/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/application/src/context/ReactQueryProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/opt/build/repo/node_modules/next-auth/react.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/reactflow/dist/style.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/opt/build/repo/node_modules/sonner/dist/index.mjs");
